<template>
  <div class="builder__imagery">
    <div class="builder__imagery-base-layer">
      <img :src="product.builder_base_photo_fID > 0 ? product.builder_base_photo_src : product.primary_photo_src" :alt="product.primary_photo_alt">
    </div>

    <div v-for="src in imageryLayerSrcs" class="builder__imagery-option-layer">
      <img :src="src" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'builder-imagery',
    props: ['product', 'imageryLayerSrcs'],
  }
</script>



// WEBPACK FOOTER //
// Imagery.vue?3099fdcb